module.exports = __webpack_public_path__ + "components/star-rating/static/white/11-e75893a1b0a0c6c9afbf919e01bb4666.svg";